import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { MandatoryMfaEnrollment } from './mandatory-mfa-enrollment'
import { adminMfaStatusQueryOptions } from './mfa-status-query'

/**
 * Double facteur obligatoire (S1.4b) : un compte contraint (date passée, droits sensibles, pas
 * enrôlé) ne voit que l'enrôlement, à la place de toutes les routes. Le serveur lui refuse le
 * reste (403 `mfa_enrollment_required`), identité et droits compris : sans cette garde, la page
 * de connexion le renverrait à elle-même. L'état charge en même temps que l'identité.
 */
export function MfaEnrollmentGate({ children }: { children: ReactNode }) {
  const { data: status, isLoading } = useQuery(adminMfaStatusQueryOptions())
  if (isLoading) return null
  if (status?.obligation.enforced) {
    return <MandatoryMfaEnrollment requiredFrom={status.obligation.requiredFrom} />
  }
  return children
}
